define('models/causes/cause_collection',["backbone",
        "models/causes/cause"
], function (Backbone, AccountItem) {
    var AccountList = Backbone.Collection.extend({
        url: function () {
            if (this.instanceURL)
                return this.instanceURL;
            var url = pf.accountsURL;
            return url;
        },
        model: AccountItem,
        initialize: function (options) {
            options = options || {};
            this.instanceURL = options.instanceURL;
            if (options.pageSize > 0)
                this.pageSize = parseInt(options.pageSize);
            else
                this.pageSize = 10;
        },
        parse: function (resp, options) {

            this.currentPage = resp.currentPage;
            this.totalRecords = resp.total_count;
            this.totalPages = this.totalRecords / this.pageSize;

            if (resp.items)
                return resp.items;
            else
                return resp;
        }
    });
    return AccountList;
});

